export default function config() {
  const tableColumns = [
    { key: 'index', label: '#', thStyle: { width: '80px' } },
    { key: 'protocol_number', label: 'Protocol number', sortable: true },
    { key: 'protocol_date', label: 'Protocol date', sortable: true },
    { key: 'file', label: 'File' },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
  }
}
